(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["calm-collection-guide"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-fit-finder]').forEach((finder) => {
    if (finder.dataset.fitFinderReady === 'true') return;
    finder.dataset.fitFinderReady = 'true';

    const primaryStep = finder.querySelector('[data-fit-step="primary"]');
    const busyStep = finder.querySelector('[data-fit-step="busy"]');
    const resultsWrap = finder.querySelector('[data-fit-results]');
    const results = Array.from(finder.querySelectorAll('[data-fit-result]'));
    // Keep the collection selector complete while contextualizing the homepage pathway.
    const pathway = new URLSearchParams(window.location.search).get('path');
    const intro = finder.closest('.calm-collection-guide')?.querySelector('.calm-collection-guide__heading > div');
    const heading = finder.closest('.calm-collection-guide')?.querySelector('.calm-collection-guide__heading h2');
    if (intro && pathway === 'everyday') {
      if (heading) heading.textContent = 'Find Your Everyday Play';
      intro.textContent = 'Everyday moments: restaurant waits, at-home play, busy hands and big feelings. Choose what sounds familiar and we\'ll help you find a good fit.';
    } else if (intro && pathway === 'adventures') {
      intro.textContent = 'A new adventure coming up? Explore first-flight preparation, portable play and other family favourites for the journey.';
    }


    const hideResults = () => {
      results.forEach((result) => {
        result.hidden = true;
      });
      resultsWrap.hidden = true;
    };

    const showPrimary = () => {
      hideResults();
      busyStep.hidden = true;
      primaryStep.hidden = false;
      const firstButton = primaryStep.querySelector('[data-fit-choice]');
      if (firstButton) firstButton.focus();
    };

    const showBusy = () => {
      hideResults();
      primaryStep.hidden = true;
      busyStep.hidden = false;
      const firstButton = busyStep.querySelector('[data-fit-choice]');
      if (firstButton) firstButton.focus();
    };

    const showResult = (route) => {
      const result = finder.querySelector('[data-fit-result="' + route + '"]');
      if (!result) return;
      primaryStep.hidden = true;
      busyStep.hidden = true;
      hideResults();
      resultsWrap.hidden = false;
      result.hidden = false;
      requestAnimationFrame(() => result.focus({ preventScroll: true }));
    };

    finder.querySelectorAll('[data-fit-choice]').forEach((button) => {
      button.addEventListener('click', () => {
        const route = button.dataset.fitChoice;
        if (route === 'busy') {
          showBusy();
        } else {
          showResult(route);
        }
      });
    });

    finder.querySelectorAll('[data-fit-reset]').forEach((button) => {
      button.addEventListener('click', showPrimary);
    });

    const back = finder.querySelector('[data-fit-back]');
    if (back) back.addEventListener('click', showPrimary);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-calm-crew-series"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-calm-crew-reveal]').forEach((comparison) => {
    if (comparison.dataset.ready === 'true') return;
    comparison.dataset.ready = 'true';
    const stage = comparison.querySelector('.calm-crew-reveal__stage');
    const range = comparison.querySelector('.calm-crew-reveal__range');
    if (!stage || !range) return;
    const update = () => {
      const value = `${range.value}%`;
      stage.style.setProperty('--reveal-position', value);
      range.setAttribute('aria-valuetext', `${range.value}% after water`);
    };
    range.addEventListener('input', update);
    update();
  });

  } catch(e) { console.error(e); }
})();
})();
